
export default function CtaSection() {
  return (
    <section className="py-20 px-6 topo-cta-bg text-white relative">
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <span className="inline-block text-emerald-400 font-bold text-xs tracking-widest uppercase mb-4">
          Your Operation Is Next
        </span>
        <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-wide">
          Ready to See Results Like These?
        </h2>
        <p className="text-xl text-gray-300 mb-10 leading-relaxed font-light max-w-2xl mx-auto">
          Every operation is different. Let&apos;s talk about your fields, your challenges, and whether precision aerial services make sense for you.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="/#contact"
            className="inline-block bg-emerald-700 hover:bg-emerald-600 text-white font-bold px-10 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-lg tracking-wide"
          >
            Start a Conversation
          </a>
          <a
            href="tel:7179131780"
            className="inline-flex items-center gap-2 border border-white/30 hover:border-white/60 text-white font-bold px-10 py-4 rounded-md transition-colors cursor-pointer whitespace-nowrap text-lg tracking-wide"
          >
            <i className="ri-phone-line"></i>
            Call 717-913-1780
          </a>
        </div>
      </div>
    </section>
  );
}
